import { render } from "./ConcreteBeam.vue?vue&type=template&id=07699846"
import script from "./ConcreteBeam.vue?vue&type=script&lang=js"
export * from "./ConcreteBeam.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__